export default __webpack_public_path__ + "static/media/Mota.cf1c643f.png";